import { Component, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap';

@Component({
  selector: 'app-success-modal',
  templateUrl: './success-modal.component.html',
  styleUrls: ['./success-modal.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SuccessModalComponent implements OnInit {
  message: string;
  title: string;
  type: number;
  isCancelled = false;
  ok = () => {};
  constructor(public bsModalRef: BsModalRef) {} 

  ngOnInit() {
    
  }  
  
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/shared/components/success-modal/success-modal.component.ts